/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUnitoSalesforceDevIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-salesforce-dev" */ './utils').then(
			(m) => m.ForgeUnitoSalesforceDevIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-dev/icon' },
);

const LazyForgeUnitoSalesforceDevSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-salesforce-dev-search-result" */ './utils').then(
			(m) => m.ForgeUnitoSalesforceDevSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoSalesforceDevIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoSalesforceDevIconComponent />
	</Suspense>
);

export const ForgeUnitoSalesforceDevSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoSalesforceDevSearchResultIconComponent />
	</Suspense>
);
